'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Error:', error);
  }, [error]);

  return (
    <div className="container mx-auto px-4 py-24">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <span className="text-8xl">⚠️</span>
        </div>

        <h1 className="text-5xl font-bold text-foreground mb-4">
          Something Went Wrong
        </h1>

        <p className="text-xl text-foreground-secondary mb-8">
          We encountered an unexpected error. Our team has been notified.
        </p>

        {error.message && (
          <div className="mb-8 p-4 bg-surface rounded border border-border text-sm text-foreground-tertiary font-mono">
            {error.message}
          </div>
        )}

        <div className="flex gap-4 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-accent text-accent-foreground font-bold rounded-lg hover:bg-accent-hover transition-colors"
          >
            Try Again
          </button>
          <Link
            href="/"
            className="px-6 py-3 bg-surface text-foreground border border-border font-bold rounded-lg hover:border-accent/40 transition-colors"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
